module.exports = __webpack_public_path__ + "img/goals_dashboard.bf21012f.svg";